import dynamic from 'next/dynamic'
import React from 'react'

import { Box } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import Flexbox from '~/components/shared/Flexbox'
import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'

import { blogCategories } from '~/brands'

const BlogHeaderDesktop = dynamic(() => import('./BlogHeader.desktop'))
const BlogHeaderMobile = dynamic(() => import('./BlogHeader.mobile'))
const BlogSearch = dynamic(() => import('./BlogSearch'))

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      blogHeader: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.bg.primary.main,
        minHeight: 60,
        [theme.breakpoints.down('sm')]: {
          minHeight: 260
        }
      }
    }),
  { name: 'BlogHeader' }
)

const BlogHeader = () => {
  const categories = blogCategories
  const classes = useStyles()

  return (
    <>
      <Mobile>
        <Box py={2}>
          <BlogSearch isExtended />
        </Box>
      </Mobile>

      <Flexbox className={classes.blogHeader}>
        <Mobile>
          <BlogHeaderMobile categories={categories} />
        </Mobile>
        <Desktop>
          <BlogHeaderDesktop categories={categories} />
        </Desktop>
      </Flexbox>
    </>
  )
}

export default BlogHeader
